import clsx from 'clsx';

import { Message } from '@/services/types/artifact-types';

import { RecipientBadge } from './RecipientBadge';
import { buildRecipientSummary, getRecipientsByRole } from './utils';

interface RecipientsListProps {
  message: Message;
  isExpanded?: boolean;
}

export const RecipientsList = ({
  message,
  isExpanded = false,
}: RecipientsListProps) => {
  const recipientsByRole = getRecipientsByRole(message);
  const allRecipients = Object.values(recipientsByRole).flat();
  const recipientSummary = buildRecipientSummary(message);

  if (!recipientSummary) return null;

  const hasMultipleRecipients = allRecipients.length > 1;

  // Get recipients with their roles for expanded view
  const recipientsWithRoles = Object.entries(recipientsByRole).flatMap(
    ([role, recipients]) =>
      recipients.map((recipient) => ({ recipient, role })),
  );

  return (
    <div className="flex items-start min-w-0">
      {/* Recipients content */}
      <div className={clsx('flex items-start min-w-0 flex-1 text-left')}>
        <div className="min-w-0 flex-1">
          {isExpanded ? (
            // Expanded: one recipient per line, selectable
            <div className="space-y-0.5 select-text">
              {recipientsWithRoles.map(({ recipient, role }, idx) => (
                <div key={`${role}-${idx}`} className="flex items-center">
                  <RecipientBadge
                    recipient={recipient}
                    recipientRole={role}
                    size="sm"
                    showAvatar={false}
                    showRole
                    inline
                    primary={false}
                  />
                </div>
              ))}
            </div>
          ) : (
            // Collapsed: single line summary
            <span className="text-xs text-gray-600 truncate block">
              {recipientSummary}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
